export const NEWS_LETTERS_RESET_STATE = 'NEWS_LETTERS_RESET_STATE';
export const NEWS_LETTERS_CURRENT_ITEM = 'NEWS_LETTERS_CURRENT_ITEM';

export const NEWS_LETTERS_REQUEST_LOADING = 'NEWS_LETTERS_REQUEST_LOADING';
export const NEWS_LETTERS_REQUEST_SUCCESS = 'NEWS_LETTERS_REQUEST_SUCCESS';
export const NEWS_LETTERS_REQUEST_FAILED = 'NEWS_LETTERS_REQUEST_FAILED';

export const NEWS_LETTERS_CURRENT_ACTION = 'NEWS_LETTERS_CURRENT_ACTION';
export const NEWS_LETTERS_RESET_ACTION = 'NEWS_LETTERS_RESET_ACTION';